'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodeTree = undefined;

var _node_tree = require('./node_tree');

var _node_tree2 = _interopRequireDefault(_node_tree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nodeTree = exports.nodeTree = _node_tree2.default; /**
                                                        * @fileoverview 数据相关
                                                        * @author kirkzheng
                                                        */

exports.default = {
  nodeTree: nodeTree
};